import { DIGITAL_PRODUCT_TYPE } from 'services/music-product-digital/types/enums';
import { IMusicProductDigitalSettlementInfoForm } from 'services/music-product-digital/types/form';
import { IMusicProductDigitalSettlementInfoMutation } from 'services/music-product-digital/types/mutation';

export const settlementInfoFormToQuery = ({
  perTrackSettlement,
  contracts,
  perTrackContracts,
}: IMusicProductDigitalSettlementInfoForm, productType: DIGITAL_PRODUCT_TYPE): IMusicProductDigitalSettlementInfoMutation => ({
  perTrackSettlement,
  contracts: contracts.map(
    ({ contractId, divisionPercentage, startDate, endDate }) => ({
      contractId,
      divisionPercentage,
      startDate,
      endDate: endDate?.length ? endDate : null,
    })
  ),
  perTrackContracts: perTrackSettlement && productType === DIGITAL_PRODUCT_TYPE.audio
    ? perTrackContracts
        .map(track =>
          track.contracts.map(
            ({ contractId, divisionPercentage, startDate, endDate }) => ({
              contractId,
              divisionPercentage,
              startDate,
              endDate: endDate?.length ? endDate : null,
              trackId: track.trackId,
            })
          )
        )
        .flat()
    : [],
});
